<template>
    <v-container fluid>
        <v-card color="#6499faff" dark class="rounded-xl">
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        {{ $t('menu.sportClasses') }}
                    </v-col>
                    <!-- <v-col cols="12">
                        <sport-class-filters @setFilters="setFilters"/>
                    </v-col> -->
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createSportClass">
                            <v-icon dark>mdi-plus</v-icon>{{ $t('button.create') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <array-view
            :items="sportClasses"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :type="'sportClass'"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
        />
    </v-container>
</template>

<script>
    import sportClassService from '@/services/sportClass'
    import ArrayView from '@/components/ArrayView'
    // import SportClassFilters from '@/components/SportClassFilters'

    export default {
        name: 'SportClass',
        components: { ArrayView },
        data: () => {
            return {
                sportClasses: [],
                displayInfo: [
                    { text: 'table.id', value: 'id' },
                    { text: 'table.name', value: 'name' },
                    { text: 'table.sport', value: 'sport', subLevel: 'name' }
                ],
                size: 100,
                totalPages: 0,
                page: 1,
                loading: false,
                filters: null,
                message: null
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredSportClasses()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getSportClassFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredSportClasses()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredSportClasses()
            },
            handleClick(action, item) {
                this.$router.push(`/sportClasses/${item.id}/${action}`)
            },
            createSportClass() {
                this.$router.push(`/sportClasses/create`)
            },
            onDelete(item, page) {
                sportClassService.deleteSportClass(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredSportClasses()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setSportClassFilters', this.filters)
            },
            fetchFilteredSportClasses() {
                this.loading = true
                sportClassService.getFilteredSportClasses(this.filters, this.page, this.size).then(resp => {
                    this.sportClasses = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
